export const selectOptionsRefinanceType = ["Cash Out", "Rate and Term"];
